
import { useState, useEffect } from 'react';

interface ReceiptCustomization {
  title: string;
}

const DEFAULT_TITLE = "Order Summary";

export const useReceiptCustomization = (receiptId: string) => {
  const [customization, setCustomization] = useState<ReceiptCustomization>({
    title: DEFAULT_TITLE
  });

  // Load saved customization from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem(`receipt_customization_${receiptId}`);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setCustomization(parsed);
      } catch (error) {
        console.error('Failed to parse saved receipt customization:', error);
      }
    }
  }, [receiptId]);

  // Save customization to localStorage whenever it changes
  const saveCustomization = (newCustomization: Partial<ReceiptCustomization>) => {
    const updated = { ...customization, ...newCustomization };
    setCustomization(updated);
    localStorage.setItem(`receipt_customization_${receiptId}`, JSON.stringify(updated));
  };

  return {
    customization,
    saveCustomization,
    updateTitle: (title: string) => saveCustomization({ title })
  };
};
